<template>
    <div id="mobMenus">
        <div v-if="$root.isMob()" class="mobMenu" @click="isShowMobMenu = true">
            <i class="el-icon-menu"></i>
        </div>

        <el-drawer            
            title="Menu"
            size="60%"
            :visible.sync="isShowMobMenu"
            direction="ltr">
            <el-menu v-if="!isLogin" v-loading="loading">        
                <el-menu-item index="login" @click="showMobLoginReg(0)">
                <i class="el-icon-user"></i>
                <span slot="title">登录</span>
                </el-menu-item>
                <el-menu-item index="reg" @click="showMobLoginReg(1)">
                <i class="el-icon-s-order"></i>
                <span slot="title">注册</span>
                </el-menu-item>
                <el-menu-item index="/" @click="linkTo('/')">
                    <i class="el-icon-s-home"></i>
                    <span slot="title">返回首页</span>
                </el-menu-item>  
            </el-menu>

            <el-menu v-if="isLogin" v-loading="loading" class="leftMenu" @select="linkTo" >
                <el-menu-item index="usercenter">
                    <i class="el-icon-menu"></i>
                    <span slot="title">进入用户中心</span>
                </el-menu-item>              
                <el-menu-item index="/">
                    <i class="el-icon-s-home"></i>
                    <span slot="title">返回首页</span>
                </el-menu-item>        
            </el-menu>
        </el-drawer>

        <el-dialog
            title="登录/注册"
            :visible.sync="isShowMobLoginReg"
            width="80%">
            <div v-if="mobLoginType == 0" v-loading="loading">
                <el-input
                    class="loginInput"
                    placeholder="请输入邮箱/手机号"
                    prefix-icon="el-icon-user"
                    v-model="username">
                </el-input>
                <el-input
                    class="loginInput"
                    placeholder="请输入密码"
                    prefix-icon="el-icon-lock"
                    show-password
                    v-model="password">
                </el-input>
                <div class="tools">
                    <div @click="showForget = true">忘记密码</div>
                </div>
                <div class="buttonGroup">
                    <el-button type="primary" @click="login()">登录</el-button>
                    <el-button type="primary" plain @click="mobLoginType = 1">注册</el-button>
                </div>
            </div>
            <div v-if="mobLoginType == 1" v-loading="getCaptchaLoading || loading" @keyup.enter="register">
                <el-input
                    ref="name"
                    class="loginInput"
                    placeholder="请输入姓名"
                    clearable
                    v-model="regForm.name">
                </el-input>
                <!-- <el-input
                    class="loginInput"
                    placeholder="请输入单位"
                    clearable
                    v-model="regForm.company">
                </el-input> -->
                <div class="row">
                    <el-input
                        ref="email"
                        class="loginInput email"
                        placeholder="请输入Email地址"
                        clearable
                        v-model="regForm.email">
                    </el-input>
                    <div :class="getCaptchaClass" @click="getCaptcha(false,'register')">{{ getCaptchaText }}</div>
                </div>                
                <el-input
                    ref="code"
                    class="loginInput"
                    placeholder="请输入验证码"
                    clearable
                    v-model="regForm.code">
                </el-input>
                <el-input
                    class="loginInput"
                    placeholder="请输入手机号"
                    clearable
                    v-model="regForm.mobile">
                </el-input>
                <el-input
                    ref="password"
                    class="loginInput"
                    placeholder="请输入密码"
                    show-password
                    v-model="regForm.password">
                </el-input>
                <el-input
                    ref="repassword"
                    class="loginInput"
                    placeholder="请再次输入密码"
                    clearable
                    show-password
                    v-model="regForm.repassword">
                </el-input>
                <div class="buttonGroup">
                    <el-button type="primary" @click="register">注册</el-button>
                    <el-button type="primary" plain @click="mobLoginType = 0">返回登录</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog class="dialog" title="找回密码" :visible.sync="showForget" width="80%">
            <div v-loading="getCaptchaLoading">
                <div class="forgetBox">
                    <div class="row">
                        <el-input placeholder="请输入邮箱" v-model="forgetForm.email" clearable></el-input>
                    </div>          
                    <div class="row">
                        <el-input class="captchaInput" placeholder="请输入验证码" v-model="forgetForm.captcha" clearable></el-input>
                        <div ref="getCaptcha" :class="getCaptchaClass" @click="getCaptcha()">
                            {{ getCaptchaText }}
                        </div>
                    </div>    
                    <div class="row">
                        <el-input placeholder="请输入新密码" show-password v-model="forgetForm.newpassword" clearable></el-input>
                    </div>    
                    <div class="row">
                        <el-input placeholder="请再次输入新密码" show-password v-model="forgetForm.renewpassword" clearable></el-input>
                    </div>          
                </div>
                <div class="buttonGroup">
                    <el-button type="primary" @click="submitResetpwd">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default{
    name:"mobMenus",
    data(){
        return{
            isShowMobMenu:false,
            isShowMobLoginReg:false,   
            getCaptchaLoading: false,
            showForget:false,
            loading:false,
            mobLoginType:0,
            lastGetCaptchaTime:0,
            getCaptchaClass:"getCaptcha",
            getCaptchaText:"获取验证码",
            isLogin:false,
            username:"",
            password:"",
            forgetForm:{
                email:"",
                captcha:"",
                newpassword:"",
                renewpassword:"",
            },
            regForm:{
                email:"",
                mobile:"",
                password:"",
                repassword:"",
                name:"",
                career_id:"",
                company:"",
                code:"",
            },
        }
    },
    watch:{
        "isShowMobMenu":function(v){
            if(v){
                this.checkLogin();
            }
        },
        "showForget":function(val){
            if(!val){
                this.forgetForm.email = "";
                this.forgetForm.captcha = "";
                this.forgetForm.newpassword = "";
                this.forgetForm.renewpassword = "";
            }
        },
        "isShowMobLoginReg":function(v){
            if(!v){
                this.username = "";
                this.password = "";
            }
        },
    },
    methods:{
        async checkLogin(){
            this.loading = true;
            this.isLogin = await this.$root.checkLogin();
            this.loading = false;
        },
        showMobLoginReg(type){
            this.mobLoginType = type;
            this.isShowMobLoginReg = true;
        },
        getLastGetCaptchaTime(){
            let time = window.localStorage.getItem("lastGetCaptchaTime");
            if(time){
                let now = Date.parse(new Date()) / 1000;
                if(now - time < 60){
                    this.lastGetCaptchaTime = time;
                    this.getCaptcha(true);
                }
            }
            else{
                this.lastGetCaptchaTime = 0;
            }
        },
        async getCaptcha(isSended=false,event="resetpwd"){
            //检查getCaptchaClass是否包含disabled
            if(this.getCaptchaClass.indexOf("disabled") != -1){
                return;
            }
            //转义事件
            let form = ""
            if(event == "resetpwd"){
                form = this.forgetForm;
            }
            if(event == "register"){
                form = this.regForm;
            }
            //禁用getCaptcha按钮
            this.getCaptchaClass = this.getCaptchaClass + " disabled";
            if(!isSended){
                this.getCaptchaLoading = true;
                let data = await this.$root.sendCaptcha(event,form);
                this.getCaptchaLoading = false;
                if(data.code == 1){
                    //获取当前时间戳
                    let getTime = Date.parse(new Date()) / 1000;
                    this.lastGetCaptchaTime = getTime;
                    window.localStorage.setItem("lastGetCaptchaTime",getTime);
                    this.$notify({
                        type: 'success',
                        title: '通知',
                        message: data.msg
                    });
                }
                else{
                    this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","");
                    this.getCaptchaClass = this.getCaptchaClass.replace("disabled","");
                    return;
                }
            }
            this.getCaptchaText = "已发送("+(59-(Date.parse(new Date()) / 1000 - this.lastGetCaptchaTime))+")";
            let listen = setInterval(() => {
                let nowTime = Date.parse(new Date()) / 1000;
                if(nowTime - this.lastGetCaptchaTime >= 60){
                    this.getCaptchaText = "获取验证码";
                    this.getCaptchaClass = this.getCaptchaClass.replace(" disabled","");
                    this.getCaptchaClass = this.getCaptchaClass.replace("disabled","");
                    clearInterval(listen);
                }
                else{
                    this.getCaptchaText = "已发送("+(59-(Date.parse(new Date()) / 1000 - this.lastGetCaptchaTime))+")";
                }                
            }, 1000);
        },
        async register(){
            this.loading = true;
            //数据验证
            let regForm = this.regForm;
            if(regForm.email == ""){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '请输入邮箱'
                });
                this.loading = false;
                this.$refs.email.focus();
                return;
            }
            if(regForm.password == ""){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '请输入密码'
                });
                this.loading = false;
                this.$refs.password.focus();
                return;
            }
            if(regForm.repassword == ""){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '请输入重复密码'
                });
                this.loading = false;
                this.$refs.repassword.focus();
                return;
            }
            if(regForm.password != regForm.repassword){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '两次密码不一致'
                });
                this.loading = false;
                return;
            }
            if(regForm.name == ""){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '请输入姓名'
                });
                this.loading = false;
                this.$refs.name.focus();
                return;
            }
            if(regForm.code == ""){
                this.$notify({
                    type: 'warning',
                    title: '通知',
                    message: '请输入验证码'
                });
                this.loading = false;
                this.$refs.code.focus();
                return;
            }
            let data = await this.$root.reg(this.regForm);
            if(data.code == 1){
                this.mobLoginType = 0;
            }
            this.loading = false;
        },
        async login(){
            this.loading = true;
            let result = await this.$root.login(this.username,this.password);
            this.loading = false;
            if(result){
                this.isShowMobMenu = false;
                this.isShowMobLoginReg = false;
            }            
        },
        async submitResetpwd(){
            this.getCaptchaLoading = true;
            let data = await this.$root.resetpwd(this.forgetForm);
            if(data){
                if(data.code == 1){
                    this.$notify({
                        type: 'success',
                        title: '通知',
                        message: data.msg
                    });
                    this.showForget = false;
                }
                else{
                    this.$notify({
                        type: 'error',
                        title: '错误',
                        message: data.msg
                    });
                }
            }
            this.getCaptchaLoading = false;
        },
        linkTo(url){
            this.$router.replace(url+"?isFromHome=1");
        },
    },
    mounted(){        
        this.getLastGetCaptchaTime();
        if(this.$route.query.redirect && this.$route.query.redirect.djId){
            this.showMobLoginReg(0);
        }
    }
}
</script>

<style lang="scss" scoped src="@/assets/css/lib/mobMenus.scss"></style>